module.exports = __webpack_public_path__ + "media/images/close-popup-icon-a6db234598a05772b92e0235e7f3e4db746504dab2299c29d0793e45ec9ccedf.svg";